import React from "react";
import DepositBalanceTable from "./DepositBalanceTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const DepositBalanceIndex = () => (
  <ReportProgramsPage
    TableComponent={DepositBalanceTable}
    loadingMessage="Loading deposit balance..."
  />
);

export default DepositBalanceIndex;
